import { Phone, MessageCircle } from "lucide-react";
import { COMPANY } from "@/data/services";

export default function FloatingActions() {
  return (
    <div className="fixed bottom-6 left-6 z-40 flex flex-col gap-3 lg:bottom-8 lg:left-8" data-testid="floating-actions">
      <a
        href={COMPANY.whatsapp}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp"
        aria-label="Contacter sur WhatsApp"
        className="w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-xl hover:scale-110 transition-transform"
      >
        <MessageCircle className="w-6 h-6" />
      </a>
      <a
        href={`tel:${COMPANY.phone}`}
        data-testid="floating-call"
        aria-label="Appeler maintenant"
        className="w-14 h-14 rounded-full bg-terracotta text-white flex items-center justify-center shadow-xl hover:scale-110 transition-transform lg:hidden"
      >
        <Phone className="w-6 h-6" />
      </a>
    </div>
  );
}
